import BASE_RULE from '../baseRule';
import {UserType, SearchTypeUser} from './constants';
import {UserRule} from './types';

export const userRuleDefaults: UserRule = {
	...BASE_RULE,
	elementType: SearchTypeUser,
	elementSubType1: UserType.IMPORTED_BY,
	elementSubType2: 0,
	elementValue1: 0,
};

export default userRuleDefaults;
